import React from 'react';
import ClassAssembly6B2024  from 'views/ClassAssembly6B2024';
import { ClassAssembly6D2024 } from '../views';
const ClassAssemblyPage = () => {
    return <ClassAssembly6D2024/>;
  }; 
  export default ClassAssemblyPage;